import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Card } from 'react-bootstrap';
import { academyStore } from '../stores/AcademyStore';
const AddAcademyCard = observer(() => {
    const handleAddClick = () => {
        academyStore.openCreateDialog();
    };
    return (_jsx(Card, { className: "h-100 add-academy-card", onClick: handleAddClick, style: { cursor: 'pointer' }, children: _jsxs(Card.Body, { className: "d-flex flex-column align-items-center justify-content-center text-center p-mobile", children: [_jsx("div", { className: "rounded-circle bg-primary d-flex align-items-center justify-content-center mb-3", style: {
                        width: '56px',
                        height: '56px',
                        minWidth: 'var(--touch-target-min)',
                        minHeight: 'var(--touch-target-min)'
                    }, children: _jsx("i", { className: "bi bi-plus text-white", style: { fontSize: 'var(--font-size-2xl)' } }) }), _jsx(Card.Title, { className: "h6 mb-2 text-mobile-sm", children: "Add New Academy" }), _jsx(Card.Text, { className: "text-muted small", children: "Click to create a new cricket academy" })] }) }));
});
export default AddAcademyCard;
